import { useT } from '@transifex/react'
import React from 'react'
import { useAppSelector } from '../../../../state/hooks'
import { selectCurrentSale } from '../../../../state/slices/currentSale/currentSaleSlice'
import { getDisabledTooltipMessage, TooltipContext } from '../add-row-tooltips'

export interface DiscountLabelProps {
  disabled: boolean
  onClick: () => void
}

export interface DiscountLabelModel {
  disabled: boolean
  onClick: () => void
  tooltipInfo: { title: string; message: React.ReactNode } | null
}

export const useDiscountLabelModel = (
  props: DiscountLabelProps
): DiscountLabelModel => {
  const t = useT()
  const currentSale = useAppSelector(selectCurrentSale)

  const tooltipInfo = props.disabled
    ? getDisabledTooltipMessage(t, currentSale, TooltipContext.DISCOUNT) ?? null
    : null

  return { disabled: props.disabled, onClick: props.onClick, tooltipInfo }
}
